<!-- 销售控销数据操作 -->
<template>
  <div>
    <div v-if="isLoaded">
      <div class="demo-drawer__content data_action_form">
        <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="tabForm">
          <v-tabs :type="dataActionBox.actionType" :activeName="dataActionBox.boxTitle" :name="'jciName'" :value="'jciName'" :tabslist="tabForm">
            <template slot="tabs" slot-scope="scope">
              <div class="table_content_box">
                <!-- 主要信息 -->
                <div v-if="scope.index == 0">
                  <el-row>
                    <el-col :span="dataActionBox.actionType!=2?12:24">
                      <el-form @submit.native.prevent size="mini" v-if="dataActionBox.actionType!=2" id="operateBtn">
                        <el-button type="danger" size="mini" @click="delControlrule">删除控销组</el-button>
                      </el-form>
                      <el-table :height="mxHeight" ref="moviesTable" size="mini" :row-class-name="rowClassName" :row-style="rowStyle" @row-click="clickEvent" :data="controlruleList" border style="width: 100%;" @selection-change="handleSelectionChange">
                        <el-table-column label="选择操作" width="80" v-if="dataActionBox.actionType!=2">
                          <template slot-scope="scope">
                            <el-radio v-model="selectedDataIndex" :label="scope.$index" border size="mini">
                              <i class="el-icon-thumb"></i>
                            </el-radio>
                          </template>
                        </el-table-column>
                        <el-table-column label="控销组名称" prop="scmName" width="120"></el-table-column>
                        <el-table-column label="控销数量" prop="controlNum"></el-table-column>
                        <el-table-column label="已销数量" prop="outNum"></el-table-column>
                        <el-table-column label="备注" prop="remark"></el-table-column>
                        <el-table-column label="创建人名称" prop="createrName" width="120"></el-table-column>
                        <el-table-column label="创建时间" prop="createTime" width="120">
                          <template slot-scope="scope">
                            <span>{{$common.getLocalTime(scope.row.createTime)}}</span>
                          </template>
                        </el-table-column>
                      </el-table>
                      <el-table :height="mxHeight" ref="mxTable" v-if="controlruleList[selectedDataIndex] && selectedRow" size="mini" stripe :data="selectedRow" border style="width: 100%;" :show-overflow-tooltip="true">
                        <el-table-column label="客户名称" prop="cmName" width="180"></el-table-column>
                        <el-table-column label="客户编号" prop="cmCode"></el-table-column>
                        <el-table-column label="已销数量" prop="outNum"></el-table-column>
                        <el-table-column fixed="right" label="操作" width="60" align="center" v-if="dataActionBox.actionType!=2">
                          <template slot-scope="scope">
                            <el-button @click="delCm(scope.row)" type="text" size="small">删除</el-button>
                          </template>
                        </el-table-column>
                      </el-table>
                    </el-col>
                    <el-col v-if="dataActionBox.actionType!=2" :span="12" style="padding-left:10px">
                      <div id="mainInfo">
                        <el-button type="success" size="mini" @click="addMainFn">新增控销组</el-button>
                        <el-button type="danger" size="mini" @click="delMainFn">删除控销组</el-button>
                      </div>
                      <el-table :height="mxHeight" ref="mxTable" size="mini" stripe :data="sendDataInfo" border style="width: 100%;height:380px">
                        <el-table-column label="选择操作" width="80">
                          <template slot-scope="scope">
                            <el-radio v-model="selectedMainIndex" :label="scope.$index" border size="mini">
                              <i class="el-icon-thumb"></i>
                            </el-radio>
                          </template>
                        </el-table-column>
                        <el-table-column label="控销组名称" prop="scmName">
                          <template slot-scope="scope">
                            <el-input v-model.trim="sendDataInfo[scope.$index].scmName"></el-input>
                          </template>
                        </el-table-column>
                        <el-table-column label="控销数量" prop="controlNum">
                          <template slot-scope="scope">
                            <el-input v-model.trim="sendDataInfo[scope.$index].controlNum" type="number"></el-input>
                          </template>
                        </el-table-column>
                        <el-table-column label="备注" prop="scmName">
                          <template slot-scope="scope">
                            <el-input v-model.trim="sendDataInfo[scope.$index].remark"></el-input>
                          </template>
                        </el-table-column>
                      </el-table>
                      <div id="operateBtn">
                        <el-button type="success" size="mini" @click="addDetallFn">新增</el-button>
                        <el-button type="danger" size="mini" @click="delDetallFn">删除</el-button>
                        <el-button type="primary" size="mini" @click="sendDataAction('sendDataInfo')">保存</el-button>
                      </div>
                      <el-table :height="mxHeight" ref="mxTable" size="mini" stripe :data="sendDataInfo[selectedMainIndex].detallList" border style="width: 100%;height:323px" :show-overflow-tooltip="true">
                        <el-table-column label="选择操作" width="80">
                          <template slot-scope="scope">
                            <el-radio v-model="selectedDetailsIndex" :label="scope.$index" border size="mini">
                              <i class="el-icon-thumb"></i>
                            </el-radio>
                          </template>
                        </el-table-column>
                        <el-table-column label="客户名称" prop="cmName">
                          <template slot-scope="scope">
                            <el-input v-model="scope.row['cmName']" @keyup.enter.native="openSearch('3391151360249856', scope.$index, 'cmName','cmName,cmId,cmCode')">
                              <el-button @click="openSearch('3391151360249856', scope.$index, 'cmName','cmName,cmId,cmCode')" slot="append" icon="el-icon-search"></el-button>
                            </el-input>
                          </template>
                        </el-table-column>
                        <el-table-column label="客户编号" prop="cmCode"></el-table-column>
                      </el-table>
                    </el-col>
                  </el-row>
                </div>
              </div>
            </template>
          </v-tabs>
        </el-card>
        <div class="foot">
          <div>
            <el-button type="primary" @click="$emit('drawerCancel', 0)">关闭</el-button>
          </div>
        </div>
      </div>
    </div>
    <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth" :modal-append-to-body='true' :append-to-body="true">
      <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
    </el-dialog>
    <printPlan ref="printPlan"></printPlan>
  </div>
</template>
 
 <script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import NP from 'number-precision'
import SearchScheme from "@/byComponents/SearchScheme.vue";
export default {
  name: "controlruleAction",
  props: ["actionData"],
  //import引入的组件需要注入到对象中才能使用
  components: {
    SearchScheme,
  },
  data() {
    //这里存放数据
    return {
      mxHeight: 0,
      dataActionBox: {
        showStatus: false,
        openMode: "ltr" || "rtl",
        boxTitle: "新增" || "编辑",
        actionType: 0, // 0新增，1修改
      },
      selectedIndex: 0,
      selectedDataIndex: 0,
      selectedMainIndex: 0,
      selectedDetailsIndex: 0,
      newsendDataInfo: {
        bgsId: 0,
        controlNum: "", //	控销数量
        detallList: [], //	明细信息
        remark: "", //	备注
        scmId: "", //	ID
        scmName: "", //	控销组名称
      },
      newDetail: {
        cmId: "", //	单位ID
        cmCode: "",
        cmName: "",
      },
      sendDataInfo: [],
      formDataList: [],
      seId: "",
      seWidth: "",
      seTitle: "",
      DialogVisible: false,
      seType: "",
      seIndex: 0, //选中索引
      smId: "",
      parentSearchData: {
        smId: "",
        orderType: 1, //	订单类型0.药品1.器械
        dtId: "",
      },
      isLoaded: false,
      orderId: "",
      tabForm: [
        {
          jciName: "",
        }
      ], // tab循环的主表单
      sField: "", // 赋值字段
      fField: "", //焦点字段
      nosField: "", // 不可赋值字段
      mxForm: [],
      footForm: [],
      selectedRow: [],
      selectedStyleRow: [],
      controlruleList: [],



    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {
    // "parentSearchData.smId": {
    //    handler: function (newValue, oldValue) {
    //       console.log("smId=======", newValue);
    //    },
    //    deep: true,
    // },
  },
  //方法集合
  methods: {
    delCm(row) {
      this.$confirm('确定删除该单位吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.deleteControlUnit({ ids: [row.scdId] }).then(() => this.controlruleControlrule())
      }).catch(() => { });
    },
    delControlrule() {
      if (this.controlruleList.length < 1) {
        return this.$message({
          message: "暂无控销组",
          type: "warning",
        });
      }
      this.$confirm('确定删除该控销组吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.deleteControlGroup({ ids: [this.controlruleList[this.selectedDataIndex].scmId] }).then(() => this.controlruleControlrule())
      }).catch(() => { });
    },
    addMainFn() {
      this.sendDataInfo.push(JSON.parse(JSON.stringify(this.newsendDataInfo)))
    },
    delMainFn() {
      this.sendDataInfo.splice(this.selectedMainIndex, 1)
      if (this.selectedMainIndex > 0) {
        this.selectedMainIndex -= 1
      } else {
        this.selectedMainIndex = 0
      }
    },
    addDetallFn() {
      this.sendDataInfo[this.selectedMainIndex].detallList.push(JSON.parse(JSON.stringify(this.newDetail)))
    },
    delDetallFn() {
      this.sendDataInfo[this.selectedMainIndex].detallList.splice(this.selectedDetailsIndex, 1)
    },

    // 保存已选择行
    handleSelectionChange(rows) {
      this.selectedStyleRow = rows; // 保存已选择行
    },
    clickEvent(row, column, event, params) {
      this.selectedRow = row.detailList
      let refsElTable = this.$refs.moviesTable; // 获取表格对象
      this.selectedIndex = row.rowIndex;
      let findRow = {};
      findRow = this.selectedStyleRow.find((c) => c.rowIndex == row.rowIndex); //找出当前选中行
      //如果只有一行且点击的也是这一行则取消选择 否则清空再选中当前点击行
      if (findRow && this.controlruleList.length === 1) {
        refsElTable.toggleRowSelection(row, false);
        return;
      }
      refsElTable.clearSelection();
      refsElTable.toggleRowSelection(row);
    },

    // 赋值字段
    paramValue(val) {
      let arr = this.sField.split(",");
      arr.forEach((item) => {
        this.sendDataInfo[item] = val[item];
      });
    },
    // 表格赋值字段
    mxParamValue(val) {
      let arr = this.sField.split(",");
      arr.forEach((item) => {
        this.sendDataInfo[this.selectedMainIndex].detallList[this.seIndex][item] = val[item];
      });
    },
    // 清除赋值字段数据
    clearValue() {
      let arr = this.sField.split(",");
      arr.forEach((item) => {
        this.sendDataInfo[item] = "";
      });
    },
    //提取返回
    changeInputModel(val) {
      console.log("返回", val);
      if (val != "" && val != undefined) {
        this.DialogVisible = false;
        if (this.seType == "bgmName") {
          this.paramValue(val);
        } else {
          this.mxParamValue(val);
        }
      }
    },
    getSeWidth(e) {
      this.seWidth = e + "%";
    },
    getSearchName(e) {
      this.seTitle = e;
    },
    // 检索Id, 索引(表格中), 标识
    //        检索Id, 索引， 字段名，赋值字段，焦点字段, 不可赋值字段
    openSearch(sId, index, type, sField, fField, nosField) {
      this.DialogVisible = true;
      this.seId = sId;
      this.seIndex = index;
      this.seType = type;
      this.sField = sField;
      this.fField = fField;
      if (type == "bgmName") {
        this.seId = sId;
        this.seIndex = index;
        this.seType = type;
        this.sField = sField;
        this.fField = fField;
      }

      // if (type == "bgmName") {
      //    this.parentSearchData.stId = this.sendDataInfo.stId;
      //    this.parentSearchData.cmId = this.sendDataInfo.cmId;
      //    this.parentSearchData.coId = this.sendDataInfo.coId;

      //    this.parentSearchData.bgmName = this.sendDataInfo.bgmName;
      //    return;
      // }
      this.parentSearchData[type] = this.sendDataInfo[type];
    },
    tableRowClassName({ row, rowIndex }) {
      row.index = rowIndex;
    },
    // 表格方法
    rowClassName({ row, rowIndex }) {
      let rowName = "",
        findRow = this.selectedStyleRow.find((c) => c.rowIndex === row.rowIndex);
      if (findRow) {
        rowName = "rowStyle "; // 可以通过此处给选中行一个class，根据自己需求更改样式
      }
      return rowName; //也可以再加上其他类名 如果有需求的话
    },
    rowStyle({ row, rowIndex }) {
      Object.defineProperty(row, "rowIndex", {
        // 给每行添加不可枚举属性rowIndex来标识当前行
        value: rowIndex,
        writable: true,
        enumerable: false,
      });
      let rowBackground = {}
      if (row.bgColor && row.bgColor != '') rowBackground.backgroundColor = row.bgColor
      return rowBackground
    },

    initActionBox(sendDataInfo) {
      var cancelTitle = this.dataActionBox.actionType == 0 ? "新增" : "修改";
      this.$confirm("确定取消" + cancelTitle + "吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$emit("drawerCancel", 0);
          // this.$parent.getDataList()
          // this.$refs[sendDataInfo][0].resetFields();
        })
        .catch(() => { });
    },

    openBox() {
      this.dataActionBox.actionType = this.actionData.cate;
      var oldData = this.actionData.oldData;
      if (this.dataActionBox.actionType == 0) {
        this.dataActionBox.boxTitle = "新增信息";
        this.dataActionBox.openMode = "ltr";
        this.newsendDataInfo.bgsId = this.actionData.oldData.bgsId;
        this.sendDataInfo = []
        this.sendDataInfo.push(JSON.parse(JSON.stringify(this.newsendDataInfo)))
        this.controlruleControlrule().then(res => {
          this.sendDataInfo[0].controlNum = NP.minus(this.actionData.oldData.num, this.controlruleList.reduce((p, c) => NP.plus(p, c.controlNum), 0))
        })
        // this.initDefaultValue();
      } else if (this.dataActionBox.actionType == 1) {
        this.dataActionBox.boxTitle = "编辑信息";
        this.dataActionBox.openMode = "rtl";
        var dataInfo = JSON.parse(JSON.stringify(oldData));
        for (let key in dataInfo) {
          this.sendDataInfo[key] = dataInfo[key];
        }
        console.log(this.sendDataInfo, " this.sendDataInfo");
        this.smId = dataInfo.smId;
        this.parentSearchData.smId = oldData.smId;
      } else {
        this.dataActionBox.boxTitle = "查看信息";
        this.controlruleControlrule()
      }
      this.tabForm[0].jciName = this.dataActionBox.boxTitle

      this.$nextTick(() => {
        setTimeout(() => {
          if (this.dataActionBox.actionType != 2) {
            this.mxHeight = this.$common.getBtnHeight() / 2
          } else {
            this.mxHeight = this.$common.getBtnHeight() / 2
          }
        }, 16.7)
      });
    },
    // 默认值
    initDefaultValue() {
      let arr = this.formDataList[0].jurconfigform;
      arr.forEach((item) => {
        if (
          item.defaultValue != "null" &&
          item.defaultValue != null &&
          item.defaultValue != ""
        ) {
          this.sendDataInfo[item.entityField] = item.defaultValue;
        }
      });
      this.sendDataInfo.isPay = Number(this.sendDataInfo.isPay);
      this.sendDataInfo.psomBuydate = this.$moment().valueOf();
    },

    //确认新增
    async sendDataAction() {
      if (this.sendDataInfo.length < 1) {
        this.$message({
          message: "请添加控销组信息",
          type: "error",
        });
        return;
      }
      let newDetailList = []
      let detailNum = 0
      for (let i = 0; i < this.sendDataInfo.length; i++) {
        const v = this.sendDataInfo[i];
        if (v.scmName == "" || v.controlNum == "") {
          this.$message({
            message: `销组组名称和数量为必填信息，请完善第${i + 1}行信息`,
            type: "error",
          });
          return false;
        }
        if (this.sendDataInfo[i].detallList.length < 1) {
          this.$message({
            message: `请添加第${i + 1}行客户信息`,
            type: "error",
          });
          return false;
        }
        if (!this.sendDataInfo[i].detallList.every(v => v.cmId)) {
          this.$message({
            message: "请删除空客户条目",
            type: "error",
          });
          return false;
        }
        detailNum = NP.plus(detailNum, v.controlNum)
        newDetailList = newDetailList.concat(this.sendDataInfo[i].detallList)
      }
      detailNum = this.controlruleList.reduce((p, c) => NP.plus(p, c.controlNum), detailNum)
      if (detailNum > this.actionData.oldData.num) {
        this.$message({
          message: "控销数量不能大于库存数量！",
          type: "error",
        });
        return;
      }
      const newDetailList1 = newDetailList.map(v => v.cmId)
      const newDetailList2 = new Set(newDetailList1)
      if (newDetailList1.length != newDetailList2.size) {
        this.$message({
          message: "请勿添加相同客户的控销组！",
          type: "error",
        });
        return;
      }
      // console.log('sendDataInfo',this.sendDataInfo);
      if (this.dataActionBox.actionType == 0) {
        var responseData = await this.$http.controlruleAdd(this.sendDataInfo);
      } else {
        var responseData = await this.$http.updatepscontrol(
          this.newsendDataInfo
        );
      }
      if (responseData.status == 200) {
        this.$message({
          message: "操作成功",
          type: "success",
        });
        this.$emit("drawerCancel", 1);
        // this.sendDataInfo = []
        // this.sendDataInfo.push(JSON.parse(JSON.stringify(this.newsendDataInfo)))
        // this.controlruleControlrule().then(res=>{
        //     this.sendDataInfo[0].controlNum = NP.minus(this.actionData.oldData.num, this.controlruleList.reduce((p,c)=>NP.plus(p, c.controlNum),0))
        // })
      } else {
        this.$message({
          message: responseData.message,
          type: "error",
        });
      }
    },

    // 获取控销组
    controlruleControlrule() {
      return new Promise((rev, reje) => {
        this.$http.controlruleControlrule({ ids: [this.actionData.oldData.bgsId] }).then(responseData => {
          if (responseData && responseData.status == 200) {
            // let resData = JSON.parse(JSON.stringify(responseData));
            this.controlruleList = responseData.result;
            this.selectedDataIndex = 0;
            if (this.controlruleList.length > 0) {
              // console.log(this.$refs.moviesTable, this.controlruleList[0]);
              this.selectedRow = this.controlruleList[0].detailList
              this.selectedStyleRow = []
              this.selectedStyleRow.push(this.controlruleList[0])
              // let refsElTable = this.$refs.moviesTable
              // refsElTable.toggleRowSelection(this.selectedStyleRow[0], false);
            } else {
              this.selectedRow = []
            }
            rev()
          } else {
            this.$message({
              message: responseData.message,
              type: "error",
            });
          }
        }).catch(rej => {
          this.$message({
            message: rej.message,
            type: "error",
          });
          reje()
        })
      })
    },


  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.$nextTick(() => {
      this.openBox();
      this.isLoaded = true;
    });
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
  },
  beforeDestroy() {
  },
  beforeCreate() { }, //生命周期 - 创建之前
  beforeMount() { }, //生命周期 - 挂载之前
  beforeUpdate() { }, //生命周期 - 更新之前
  updated() {
  }, //生命周期 - 更新之后
  destroyed() { }, //生命周期 - 销毁完成
  activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
 
 <style scoped>
/* ::v-deep .current-row td {
    background-color: #fff7ca !important;
} */
.el-table .rowStyle {
  background: #fff7ca !important;
}

.table_button_box {
  height: 200px;
  background-color: red;
}

.table_content_box {
  /* height: 500px !important; */
  overflow-y: auto;
}

.el-row {
  display: flex;
  flex-wrap: wrap;
  padding-right: 2px;
}

.el-drawer {
  outline: none;
}

.v-modal {
  position: static !important;
  width: 100%;
  height: 100%;
  background: transparent;
}
#mainInfo {
  padding-bottom: 5px !important;
}
</style>